export default "__VITE_ASSET__DQQDiggb__"